module.exports = __webpack_public_path__ + "img/Section-5.e30d055b.png";